import { render, staticRenderFns } from "./profitDetail.vue?vue&type=template&id=dd06d720&scoped=true"
import script from "./profitDetail.vue?vue&type=script&lang=js"
export * from "./profitDetail.vue?vue&type=script&lang=js"
import style0 from "./profitDetail.vue?vue&type=style&index=0&id=dd06d720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd06d720",
  null
  
)

export default component.exports